module.exports = __webpack_public_path__ + "static/mccarthy-hall-3-thumb-eb65f14af17baef659e7904214f0816a.jpg";